import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { LOGO_PLACEMENT } from "../case-study/brand-logo-scales"
import BrandLogoImg from "../case-study/brand-logo-img"

const CaseStudiesList = ({ caseStudies }) => {
  const formatTitleWithHyphens = htmlString => {
    if (!htmlString) return htmlString
    return htmlString.replace(
      /(\w+-\w+)/g,
      '<span style="white-space: nowrap;">$1</span>'
    )
  }

  const sortedCaseStudies = [...caseStudies].sort((a, b) => {
    const orderA = a.acf?.order || 0
    const orderB = b.acf?.order || 0
    return orderA - orderB
  })

  return (
    <div className="case-studies-list-container">
      <div className="case-studies-container">
        <div className="case-studies-list">
          {sortedCaseStudies.map((caseStudy, index) => {
            const isEven = index % 2 === 0
            const textFirst = isEven
            const isFirst = index === 0

            const titleText = caseStudy.acf?.custom_post_title
              ? caseStudy.acf.custom_post_title.replace(
                  /<(?!\/?strong\b)[^>]*>/gi,
                  ""
                )
              : caseStudy.acf?.slug
                  ?.split("-")
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")

            const hasExternalUrl = Boolean(caseStudy.acf?.external_url)
            const brandLogo1 =
              caseStudy.acf?.brandLogo1 || caseStudy.acf?.brand_logo_1
            const brandLogo2 =
              caseStudy.acf?.brandLogo2 || caseStudy.acf?.brand_logo_2
            const brandLogo3 =
              caseStudy.acf?.brandLogo3 || caseStudy.acf?.brand_logo_3
            const logos = [brandLogo1, brandLogo2, brandLogo3].filter(Boolean)
            const hasBrandPair = logos.length >= 2
            const slug = caseStudy.acf?.slug ? caseStudy.acf.slug.trim() : ""
            const caseStudyLink = slug
              ? `/case-studies/${slug}`
              : "/case-studies"

            return (
              <CardLink
                key={caseStudy.id || index}
                hasExternalUrl={hasExternalUrl}
                externalUrl={caseStudy.acf?.external_url}
                caseStudyLink={caseStudyLink}
                className={`case-studies-list-card ${
                  textFirst ? "" : "case-studies-list-card--reversed"
                } ${isFirst ? "case-studies-list-card--first" : ""}${
                  hasBrandPair ? " case-studies-list-card--with-brands" : ""
                }`}
              >
                <div className="case-studies-list-card-text is-flex is-flex-direction-column is-justify-content-space-between">
                  <div className="is-flex is-flex-direction-column case-studies-list-card-content">
                    <h2
                      className="case-studies-list-card-title has-text-weight-semibold has-text-purple"
                      dangerouslySetInnerHTML={{
                        __html: formatTitleWithHyphens(titleText),
                      }}
                    />
                    <div className="case-study-card--brand-slot">
                      {hasBrandPair && (
                        <div className="case-study-card--brand-logos">
                          {logos.map((src, i) => (
                            <React.Fragment key={i}>
                              {i > 0 && (
                                <span
                                  className="case-study-card--brand-plus"
                                  aria-hidden="true"
                                >
                                  +
                                </span>
                              )}
                              <BrandLogoImg
                                src={src}
                                alt=""
                                context={LOGO_PLACEMENT.caseStudiesListPage}
                              />
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                    </div>

                    {caseStudy.acf?.summary && (
                      <p className="case-studies-list-card-description has-text-purple has-text-weight-light">
                        {caseStudy.acf.summary}
                      </p>
                    )}
                  </div>
                  <div className="button is-rounded is-link">
                    View case study
                  </div>
                </div>
                <div className="case-studies-list-card-image">
                  {caseStudy.acf?.hero?.localFile?.childImageSharp?.fluid && (
                    <Img
                      fluid={caseStudy.acf.hero.localFile.childImageSharp.fluid}
                      alt={titleText || "Case Study"}
                      backgroundColor="transparent"
                      style={{
                        width: "100%",
                        height: "100%",
                        paddingBottom: 0,
                      }}
                      imgStyle={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      fadeIn={false}
                    />
                  )}
                </div>
              </CardLink>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const CardLink = ({ externalUrl, caseStudyLink, className, children }) => {
  if (externalUrl) {
    return (
      <a
        href={externalUrl}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    )
  }

  return (
    <Link to={caseStudyLink} className={className}>
      {children}
    </Link>
  )
}

export default CaseStudiesList
